import { Box, styled } from '@mui/material';
import { PropsWithChildren } from 'react';

export const TableWrapper = styled(Box)({
  position: 'relative',
  width: '100%',

  '& .MuiTableContainer-root': {
    overflow: 'auto',
  },
});

export function TableColWrapper({ minWidth = 100, children }: PropsWithChildren<{ minWidth?: number }>) {
  return <Box sx={{ minWidth }}>{children}</Box>;
}
